export default __webpack_public_path__ + "static/media/GCP.8b953400.png";